var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "navbar-offcanvas",
      attrs: { role: "navigation", id: "js-bootstrap-offcanvas-nav" },
    },
    [
      _c("div", { staticClass: "dashboard-nav__container" }, [
        _c(
          "ul",
          { staticClass: "sidemenu" },
          [
            !_vm.$whitelabel && _vm.$vlastMode
              ? _c(
                  "div",
                  { staticClass: "mobile-logo" },
                  [
                    _c("vlast-logo-full", {
                      staticClass: "vlast-logo vlast-logo--full",
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.$userIsReportingAdmin
              ? _c(
                  "li",
                  { staticClass: "sidemenu__item sidemenu__item--staple-top" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "sidemenu__link",
                        attrs: {
                          tag: "a",
                          to: { name: "dashboard", query: { src: "menu" } },
                          exact: "",
                        },
                      },
                      [
                        _c("i", { staticClass: "sidemenu__icon fa fa-home" }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Home")]),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.navigationItems, function (link, index) {
              return _c(
                "li",
                {
                  key: link.id,
                  staticClass: "sidemenu__group",
                  class: {
                    "sidemenu__group--cta": link.cta,
                    "sidemenu__group--expanded": link.expanded || !link.heading,
                    "sidemenu__group--active": _vm.isActive(index),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.trackParent(link)
                    },
                  },
                },
                [
                  link.heading
                    ? _c("div", { staticClass: "sidemenu__heading" }, [
                        _c(
                          "button",
                          {
                            staticClass: "sidemenu__toggle",
                            on: {
                              click: function ($event) {
                                return _vm.toggleActive(index)
                              },
                            },
                          },
                          [
                            _c("span", [_vm._v(_vm._s(link.heading))]),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "sidemenu__toggle-icon",
                            }),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "sidemenu__list" },
                    _vm._l(link.items, function (child) {
                      return _c(
                        "li",
                        {
                          key: child.id,
                          staticClass: "sidemenu__item",
                          class: { "sidemenu__item--featured": child.featured },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.trackChild(child)
                            },
                          },
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "sidemenu__link",
                              class: {
                                "sidemenu__link--child":
                                  link.items.length > 1 || link.heading,
                              },
                              attrs: {
                                tag: "a",
                                to: { name: child.view },
                                exact: "",
                              },
                            },
                            [
                              child.counter
                                ? _c(
                                    "span",
                                    { staticClass: "sidemenu__counter" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(child.counter) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(child.label) +
                                    "\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              child.icon
                                ? _c("i", {
                                    staticClass: "fa sidemenu__icon",
                                    class: `fa-${child.icon}`,
                                  })
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]
              )
            }),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass:
                  "sidemenu__item sidemenu__item--staple-bottom sidemenu__item--visible-sm",
              },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "sidemenu__link",
                    attrs: {
                      tag: "a",
                      to: { name: "profile.show" },
                      exact: "",
                    },
                  },
                  [_vm._v("\n          My Profile\n        ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "sidemenu__item sidemenu__item--staple-bottom",
                on: {
                  click: function ($event) {
                    return _vm.trackChild({ view: "logout" })
                  },
                },
              },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "sidemenu__link",
                    attrs: { tag: "a", to: { name: "logout" }, exact: "" },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-window-close sidemenu__icon",
                    }),
                    _vm._v("\n          Logout\n        "),
                  ]
                ),
              ],
              1
            ),
          ],
          2
        ),
        _vm._v(" "),
        !_vm.$vlastMode && _vm.$userIsClient
          ? _c(
              "div",
              { staticClass: "sidemenu__helpbutton" },
              [_c("help-button")],
              1
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }